import { isStore } from 'utils/location'
import { useEssentials } from 'hooks/utils/useEssentials'
import { SecureStore } from './secure'
import { SecureNonStore } from './non-store'

export const AssetsProtectionSecure = () => {
    const { currentLocation } = useEssentials()

    return isStore(currentLocation) ? <SecureStore /> : <SecureNonStore />
}
